import type { InferGetStaticPropsType } from 'next';
import React from 'react';
import Layout from '@/layouts';
import { NextPageWithLayout } from '@/pages/_app';
import ShopAll from '@/components/Shop/ShopAll';
import type { GetServerSidePropsContext } from 'next';
import { SHOP_ALL_CONFIG } from '@/shared/utils/shop-all-helper';
import { Breadcrumb } from '@/components/Common';
import { SEO_META } from '@/shared/seo/seo';
import { MetaInfo, SEO_META_PAGES } from '@/shared/types/seo';

export async function getServerSideProps(context: GetServerSidePropsContext<any>) {
  const { params, resolvedUrl, query } = context;
  // TODO logPageView

  return {
    props: {
      query: query ?? {},
      resolvedUrl: resolvedUrl ?? '',
      params: params ?? {},
    },
  };
}

const All: NextPageWithLayout<InferGetStaticPropsType<typeof getServerSideProps>> = ({ query }) => {
  return <ShopAll param={query} />;
};

All.getLayout = function getLayout(page: React.ReactElement) {
  const { query, resolvedUrl = '' } = page.props;
  const title = () => {
    if (resolvedUrl in SHOP_ALL_CONFIG && SHOP_ALL_CONFIG[resolvedUrl].titleTag) {
      return `${SHOP_ALL_CONFIG[resolvedUrl].titleTag} | Pietra`;
    } else if (query.text || query.predefinedText) {
      return `Search "${query.text || query.predefinedText}" on Pietra`;
    } else if (query.title) {
      return `${query.title} | Pietra`;
    } else {
      return 'Shop From Our Creators | Pietra';
    }
  };
  const head = SEO_META[SEO_META_PAGES.MARKETPLACE_SHOP_ALL].head({
    title: title(),
    description: 'Shop from all our creators in the largest marketplace for creator-branded goods.',
    url: typeof window === 'object' ? window.location.href : '',
  });
  return (
    <Layout
      headers={SEO_META[SEO_META_PAGES.MARKETPLACE_SHOP_ALL].headers}
      head={head as MetaInfo}
      structured={
        SEO_META[SEO_META_PAGES.MARKETPLACE_SHOP_ALL].jsonld({
          products: [],
          url: typeof window === 'object' ? window.location.origin : '',
        }) as any
      }
    >
      <Breadcrumb
        routes={[
          { text: 'Marketplace', path: '/' },
          { text: 'Shop', path: '/shop/all' },
        ]}
      />
      {page}
    </Layout>
  );
};

export default All;
